import Chart from "react-apexcharts";

function LineChart({ title, data, xAnnt = null, intervalMinutes = 0 }) {
  if (!data || !data.x || !data.y) {
    return null;
  }

  function aggregateData(data, intervalMinutes) {
    if (!data || !data.x || !data.y) {
      return { x: [], y: [] };
    }

    const { x, y } = data;
    const aggregatedData = {};

    x.forEach((time, index) => {
      const [hour, minute] = time.split(":").map(Number);
      const totalMinutes = hour * 60 + minute;
      const interval = Math.floor(totalMinutes / intervalMinutes);
      const key = interval * intervalMinutes;

      if (!aggregatedData[key]) {
        aggregatedData[key] = { count: 0, sum: 0, times: [] };
      }

      aggregatedData[key].count += 1;
      aggregatedData[key].sum += y[index];
      aggregatedData[key].times.push(time);
    });

    const finalData = {
      x: Object.keys(aggregatedData).map((key) => aggregatedData[key].times[0]),
      y: Object.keys(aggregatedData).map(
        (key) =>
          +(aggregatedData[key].sum / aggregatedData[key].count).toFixed(2)
      ),
    };

    return finalData;
  }

  const processedData = intervalMinutes
    ? aggregateData(data, intervalMinutes)
    : data;

  const xList = processedData?.x || [];
  const yList = processedData?.y || [];
  const xLabel = data?.xLabel;
  const yLabel = data?.yLabel;
  const xAnntLabel = data?.x_annotation_label;

  if (xList.length === 0 || yList.length === 0) {
    return null;
  }

  const chartData = {
    options: {
      chart: {
        id: "apex-line-chart",
        dropShadow: {
          enabled: true,
          color: "#000",
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2,
        },
      },
      stroke: {
        curve: "smooth",
      },
      colors: ["#2D2D2B"],
      xaxis: {
        categories: xList,
        title: {
          text: xLabel,
        },
        tickAmount: 20,
        labels: {
          skipTicks: Math.ceil(xList.length / 50),
        },
      },
      yaxis: {
        title: {
          text: yLabel,
        },
      },
      annotations: {
        xaxis: [
          {
            x: xAnnt?.x || xAnnt,
            strokeDashArray: 0,
            borderColor: xAnnt?.strokeColor || "black",
            label: {
              borderColor: xAnnt?.strokeColor || "black",
              style: {
                color: "#000000",
                background: "#d0d6e2",
                fontSize: "12px",
              },
              text: xAnnt?.text || xAnntLabel || "",
            },
          },
        ],
      },
    },
    series: [
      {
        name: title,
        data: yList,
      },
    ],
  };

  return (
    <Chart
      options={chartData.options}
      series={chartData.series}
      type="line"
      height={350}
    />
  );
}

export default LineChart;
